import { BulbOutlined, CalendarOutlined, CheckOutlined, CloseOutlined, CoffeeOutlined, CrownOutlined, RocketOutlined } from "@ant-design/icons"
import * as XLSX from "xlsx"

export const tables = {
  FACT_COMPLIANCE_MONITORING: "fact_compliance_monitoring",
  FACT_PIPELINE_STATUS: "fact_pipeline_status",
  FACT_MANAGEMENT_TASK_STATUS: "fact_management_task_status",
  FACT_PIPELINE_COMMENT: "fact_pipeline_comment",
  FACT_ASSET_ALLOCATION: "fact_asset_allocation",
  FACT_ASSET_ALLOCATION_EXPLODED: "fact_asset_allocation_exploded",
  FACT_EXPECTED_RETURN: "fact_expected_return",
  FACT_DOLLAR_QUOTATION: "fact_dollar_quotation",
  FACT_MANAGEMENT_TASK_COMMENT: "fact_management_task_comment",
  FACT_PRIVATE_INVESTMENTS_ANALYSIS: "fact_private_investments_projections",
  FACT_PRIVATE_INVESTMENTS_ESTIMATED_CASHFLOW: "fact_private_investments_estimated_cashflow",
  FACT_BRAZILIAN_TREASURY_BOND_SPREAD: "fact_brazilian_treasury_bond_spread",
  FACT_POSITION_BY_STRUCTURE: "fact_position_by_structure",
  DIM_STRUCTURE: "dim_structure",
  DIM_TERA_FUND: "dim_tera_fund",
  DIM_ASSET_CLASS: "dim_asset_class",
  DIM_ASSET: "dim_asset",
  DIM_CUSTOMER: "dim_customer",
  DIM_PIPELINE_ASSET: "dim_pipeline_asset",
  DIM_MANAGEMENT_TASK: "management_task",
  PIPELINE_ATTACHMENT: "pipeline_attachment",
  MANAGEMENT_TASK_ATTACHMENT: "management_task_attachment",
  PRIVATE_INVESTMENT_ESTIMATIVE: "private_investment_estimative",
  VIEW_POSITIONS_DATES_AVAILABLE: "view_positions_dates_available",
  VIEW_ASSET_CLASS_PARENT: "view_asset_class_parent",
  MATURITY_DECISION: "maturity_decision",
  PRIVATE_INVESTMENT: "private_investment",
  PRIVATE_INVESTMENT_ASSUMPTION: "private_investment_assumption",
  PRIVATE_INVESTMENT_ATTACHMENT: "private_investment_attachment",
  PRIVATE_INVESTMENT_COMMENT: "private_investment_comment",
}

export const filesQuantFormats = {
  PDF: "pdf",
  HTML: "html",
}

export const pipelineStatus = {
  ON_GOING: {
    text: "Em Andamento",
    description: "Em análise pela equipe",
    icon: <BulbOutlined style={{ fontSize: 24 }} />,
  },
  APPROVED: {
    text: "Aprovado",
    description: "Prontos para investimento ou já aplicados",
    icon: <CheckOutlined style={{ fontSize: 24 }} />,
  },
  STAND_BY: {
    text: "Stand By",
    description: "Aprovados, mas com impedimentos para aporte",
    icon: <CoffeeOutlined style={{ fontSize: 24 }} />,
  },
  REPPROVED: {
    text: "Reprovado",
    description: "Não passaram pelo crivo da Gestão",
    icon: <CloseOutlined style={{ fontSize: 24 }} />,
  },
}

export const tasksStatus = {
  PLANNED: {
    text: "Planejado",
    description: "Demandas e decisões que estão no radar",
    icon: <CalendarOutlined style={{ fontSize: 24 }} />,
  },
  ON_GOING: {
    text: "Em andamento",
    description: "O que está sendo feito agora",
    icon: <RocketOutlined style={{ fontSize: 24 }} />,
  },
  DONE: {
    text: "Concluído",
    description: "Feito",
    icon: <CrownOutlined style={{ fontSize: 24 }} />,
  },
}

export const classColors = {
  Cash: "#050505",
  "Cash BZ": "#050505",
  "Core Bonds": "#626367",
  "Core Bonds BZ": "#626367",
  "Credit Bonds": "#96bbf7ff",
  "Credit Bonds BZ": "#96bbf7ff",
  "Public Equity": "#006AFF",
  "Public Equity BZ": "#006AFF",
  "Private Investments": "#002060",
  "Private Investments BZ": "#002060",
  FX: "#1565C0",
  "FX BZ": "#1565C0",
  Gold: "#666607",
  "Gold BZ": "#666607",
  "Hedge Funds": "#F15D1B",
  "Hedge Funds BZ": "#F15D1B",
  "Trend Following": "#5C3317",
  "Real Estate and Infrastructure BZ": "#455A64",
  Commodities: "#03D54A",
  "Commodities BZ": "#03D54A",
}

export const CAMBRIDGE_ASSOCIATES_STRATEGIES = [
  "U.S. Credit Opportunities",
  "Global Private Equity",
  "Global Venture Capital",
  "U.S. Infrastructure",
  "U.S. Private Credit",
  "U.S. Real Estate",
  "U.S. Secondaries",
  "U.S. Buyouts",
  "U.S. Growth Equity",
  "U.S. Private Equity",
  "U.S. Private Equity and Venture Capital",
]

export const PREQUIN_STRATEGIES = [
  "Buyout - All",
  "Buyout - Americas",
  "Buyout - Asia",
  "Buyout - Asia & Rest of World",
  "Buyout - Asia-Pacific",
  "Buyout - Australasia",
  "Buyout - Europe",
  "Buyout - Large - All",
  "Buyout - Large - Asia",
  "Buyout - Large - Asia & Rest of World",
  "Buyout - Large - Asia-Pacific",
  "Buyout - Large - Europe",
  "Buyout - Large - North America",
  "Buyout - Mega - All",
  "Buyout - Mega - Asia",
  "Buyout - Mega - Asia & Rest of World",
  "Buyout - Mega - Asia-Pacific",
  "Buyout - Mega - Europe",
  "Buyout - Mega - North America",
  "Buyout - Mid - All",
  "Buyout - Mid - Asia & Rest of World",
  "Buyout - Mid - Asia-Pacific",
  "Buyout - Mid - Europe",
  "Buyout - Mid - North America",
  "Buyout - North America",
  "Buyout - Small - All",
  "Buyout - Small - Americas",
  "Buyout - Small - Asia",
  "Buyout - Small - Asia & Rest of World",
  "Buyout - Small - Asia-Pacific",
  "Buyout - Small - Australasia",
  "Buyout - Small - Europe",
  "Buyout - Small - North America",
  "Co-investment - All",
  "Co-investment - Europe",
  "Co-investment - North America",
  "Co-investment Multi Manager - All",
  "Co-investment Multi Manager - Europe",
  "Co-investment Multi Manager - North America",
  "Early Stage - All",
  "Early Stage - Asia",
  "Early Stage - Asia & Rest of World",
  "Early Stage - Asia-Pacific",
  "Early Stage - Australasia",
  "Early Stage - Europe",
  "Early Stage - North America",
  "Fund of Funds - All",
  "Fund of Funds - Americas",
  "Fund of Funds - Asia",
  "Fund of Funds - Asia & Rest of World",
  "Fund of Funds - Asia-Pacific",
  "Fund of Funds - Europe",
  "Fund of Funds - North America",
  "Growth - Africa",
  "Growth - All",
  "Growth - Americas",
  "Growth - Asia",
  "Growth - Asia & Rest of World",
  "Growth - Asia-Pacific",
  "Growth - Europe",
  "Growth - North America",
  "Infrastructure - All",
  "Infrastructure - Americas",
  "Infrastructure - Asia",
  "Infrastructure - Asia & Rest of World",
  "Infrastructure - Asia-Pacific",
  "Infrastructure - Europe",
  "Infrastructure - North America",
  "Natural Resources - All",
  "Natural Resources - Americas",
  "Natural Resources - Asia",
  "Natural Resources - Asia & Rest of World",
  "Natural Resources - Asia-Pacific",
  "Natural Resources - Energy - All",
  "Natural Resources - Energy - Americas",
  "Natural Resources - Energy - Asia",
  "Natural Resources - Energy - Asia & Rest of World",
  "Natural Resources - Energy - Asia-Pacific",
  "Natural Resources - Energy - Europe",
  "Natural Resources - Energy - North America",
  "Natural Resources - Europe",
  "Natural Resources - North America",
  "Private Capital - Africa",
  "Private Capital - All",
  "Private Capital - Americas",
  "Private Capital - Asia",
  "Private Capital - Asia & Rest of World",
  "Private Capital - Asia-Pacific",
  "Private Capital - Australasia",
  "Private Capital - Europe",
  "Private Capital - North America",
  "Private Debt - Africa",
  "Private Debt - All",
  "Private Debt - Americas",
  "Private Debt - Asia",
  "Private Debt - Asia & Rest of World",
  "Private Debt - Asia-Pacific",
  "Private Debt - Direct Lending - All",
  "Private Debt - Direct Lending - Asia",
  "Private Debt - Direct Lending - Asia & Rest of World",
  "Private Debt - Direct Lending - Asia-Pacific",
  "Private Debt - Direct Lending - Europe",
  "Private Debt - Direct Lending - North America",
  "Private Debt - Direct Lending - Levered - All",
  "Private Debt - Direct Lending - Levered - North America",
  "Private Debt - Direct Lending - Unlevered - All",
  "Private Debt - Direct Lending - Unlevered - Europe",
  "Private Debt - Direct Lending - Unlevered - North America",
  "Private Debt - Distressed Debt - All",
  "Private Debt - Distressed Debt - Asia & Rest of World",
  "Private Debt - Distressed Debt - Europe",
  "Private Debt - Distressed Debt - North America",
  "Private Debt - Europe",
  "Private Debt - Mezzanine - All",
  "Private Debt - Mezzanine - Asia & Rest of World",
  "Private Debt - Mezzanine - Europe",
  "Private Debt - Mezzanine - North America",
  "Private Debt - North America",
  "Private Debt - Special Situations - All",
  "Private Debt - Special Situations - Asia",
  "Private Debt - Special Situations - Asia & Rest of World",
  "Private Debt - Special Situations - Asia-Pacific",
  "Private Debt - Special Situations - Europe",
  "Private Debt - Special Situations - North America",
  "Private Debt - Venture Debt - All",
  "Private Debt - Venture Debt - North America",
  "Private Equity - Africa",
  "Private Equity - All",
  "Private Equity - Americas",
  "Private Equity - Asia",
  "Private Equity - Asia & Rest of World",
  "Private Equity - Asia-Pacific",
  "Private Equity - Australasia",
  "Private Equity - Europe",
  "Private Equity - North America",
  "Real Estate - All",
  "Real Estate - Americas",
  "Real Estate - Asia",
  "Real Estate - Asia & Rest of World",
  "Real Estate - Asia-Pacific",
  "Real Estate - Australasia",
  "Real Estate - Core - All",
  "Real Estate - Core - Asia & Rest of World",
  "Real Estate - Core - Asia-Pacific",
  "Real Estate - Core - Europe",
  "Real Estate - Core - North America",
  "Real Estate - Core-Plus - All",
  "Real Estate - Core-Plus - Europe",
  "Real Estate - Core-Plus - North America",
  "Real Estate - Core/Core-Plus - All",
  "Real Estate - Core/Core-Plus - Asia & Rest of World",
  "Real Estate - Core/Core-Plus - Asia-Pacific",
  "Real Estate - Core/Core-Plus - Europe",
  "Real Estate - Core/Core-Plus - North America",
  "Real Estate - Debt - All",
  "Real Estate - Debt - Asia & Rest of World",
  "Real Estate - Debt - Asia-Pacific",
  "Real Estate - Debt - Europe",
  "Real Estate - Debt - North America",
  "Real Estate - Distressed - All",
  "Real Estate - Distressed - North America",
  "Real Estate - Europe",
  "Real Estate - Fund of Funds - All",
  "Real Estate - Fund of Funds - Europe",
  "Real Estate - Fund of Funds - North America",
  "Real Estate - Non-Core - All",
  "Real Estate - Non-Core - Americas",
  "Real Estate - Non-Core - Asia",
  "Real Estate - Non-Core - Asia & Rest of World",
  "Real Estate - Non-Core - Asia-Pacific",
  "Real Estate - Non-Core - Europe",
  "Real Estate - Non-Core - North America",
  "Real Estate - North America",
  "Real Estate - Opportunistic - All",
  "Real Estate - Opportunistic - Americas",
  "Real Estate - Opportunistic - Asia",
  "Real Estate - Opportunistic - Asia & Rest of World",
  "Real Estate - Opportunistic - Asia-Pacific",
  "Real Estate - Opportunistic - Europe",
  "Real Estate - Opportunistic - North America",
  "Real Estate - Value Added - All",
  "Real Estate - Value Added - Asia",
  "Real Estate - Value Added - Asia & Rest of World",
  "Real Estate - Value Added - Asia-Pacific",
  "Real Estate - Value Added - Europe",
  "Real Estate - Value Added - North America",
  "Secondaries - All",
  "Secondaries - Asia",
  "Secondaries - Asia & Rest of World",
  "Secondaries - Asia-Pacific",
  "Secondaries - Europe",
  "Secondaries - North America",
  "Venture - All",
  "Venture - Americas",
  "Venture - Asia",
  "Venture - Asia & Rest of World",
  "Venture - Asia-Pacific",
  "Venture - Australasia",
  "Venture - Europe",
  "Venture - North America",
]

export const round = (num, decimalPlaces = 2) => Number(num.toFixed(decimalPlaces))

export function setNestedKey(obj, keys, value) {
  let key = keys.shift()
  if (keys.length === 0) {
    obj[key] = value
  } else {
    if (!obj.hasOwnProperty(key)) {
      obj[key] = {}
    }
    setNestedKey(obj[key], keys, value)
  }
  return obj
}

export function getAllKeys(data) {
  let keys = []
  const traverse = (items) => {
    items.forEach((item) => {
      keys.push(item.key)
      if (item.children) {
        traverse(item.children)
      }
    })
  }
  traverse(data)
  return keys
}

export function filterChildrenRecursively(data) {
  let children = []

  for (const item of data) {
    if (item.children) for (const child of filterChildrenRecursively(item.children)) children.push(child)
    else children.push(item)
  }

  return children
}

export const removeObjectsDuplicates = (arr) => Array.from(new Set(arr.map((item) => JSON.stringify(item)))).map((item) => JSON.parse(item))

export const replaceSpacesByUnderlines = (str) => str.replace(/ /g, "_")

export function findPaths(graph, start, end) {
  const result = []

  function dfs(currentOrigin, path) {
    const neighbors = graph.filter((vertex) => vertex.origin === currentOrigin)

    for (const neighbor of neighbors) {
      path.push(neighbor)

      if (neighbor.target === end) result.push(...path)
      else dfs(neighbor.target, path)

      path.pop()
    }
  }

  dfs(start, [])

  return removeObjectsDuplicates(result)
}

export const saveAs = (blob, filename) => {
  const link = document.createElement("a")
  link.href = URL.createObjectURL(blob)
  link.setAttribute("download", filename)

  document.body.appendChild(link)
  link.click()

  document.body.removeChild(link)
}

export function downloadExcelFile(data, workbookName, columns, filename) {
  const worksheet = XLSX.utils.json_to_sheet(data, { header: columns.map((column) => column.name) })
  worksheet["!cols"] = columns.map((column) => ({ wch: column.width }))

  const workbook = XLSX.utils.book_new()
  XLSX.utils.book_append_sheet(workbook, worksheet, workbookName)

  const fileData = XLSX.write(workbook, { bookType: "xlsx", type: "binary" })

  function s2ab(s) {
    const buf = new ArrayBuffer(s.length)
    const view = new Uint8Array(buf)
    for (let i = 0; i < s.length; i++) {
      view[i] = s.charCodeAt(i) & 0xff
    }
    return buf
  }

  const blob = new Blob([s2ab(fileData)], { type: "application/octet-stream" })

  saveAs(blob, filename)
}

export const getLastDateAvailable = async (supabase, table) =>
  (await supabase.from(table).select("date").order("date", { ascending: false }).limit(1)).data[0]?.date

export const fetchAllData = async (query) => {
  const limit = 1000
  let offset = 0
  let allData = []
  let hasMoreData = true

  while (hasMoreData) {
    const { data, error } = await query.range(offset, offset + limit - 1)

    if (error) {
      console.error("Error fetching data:", error)
      break
    }

    if (data.length > 0) {
      allData = allData.concat(data)
      offset += limit
    }

    if (data.length < limit) {
      hasMoreData = false
    }
  }

  return allData
}

export const fullSize = { height: "100%", width: "100%" }

export function capitalizeFirstLetter(string) {
  return string.charAt(0).toUpperCase() + string.slice(1)
}

export const findDuplicates = (array) => {
  const uniqueItems = new Set()
  const duplicates = new Set()

  array.forEach((item) => (uniqueItems.has(item) ? duplicates.add(item) : uniqueItems.add(item)))

  return Array.from(duplicates)
}

export const getInitials = (sentence) => {
  return sentence
    .split(" ")
    .map((word) => word.charAt(0).toUpperCase())
    .join("")
}

export const replaceKey = (obj, key, newKey) => {
  if (!Object.keys(obj).includes(key)) return
  obj[newKey] = obj[key]
  delete obj[key]
}

export const debounce = (func, wait) => {
  let timeout
  return function (...args) {
    clearTimeout(timeout)
    timeout = setTimeout(() => {
      func.apply(this, args)
    }, wait)
  }
}
